import { INDIVIDUAL_HIDDEN_FINANCE_CHILD_IDS } from '@/app/navigation-context/individual-finance-nav.js';
import type { NavigationLevel } from '@/app/navigation-context/types.js';
import { isShellNavGroup, type ShellNavEntry } from '@/shared/shell/nav.types.js';

export function filterNavEntriesForPersonKind(
  entries: readonly ShellNavEntry[],
  personKind: 'INDIVIDUAL' | 'COMPANY' | undefined,
  level: NavigationLevel,
): readonly ShellNavEntry[] {
  if (personKind !== 'INDIVIDUAL' || level === 'platform') {
    return entries;
  }

  return entries
    .filter((entry) => entry.id !== 'fiscal')
    .map((entry) => {
      if (!isShellNavGroup(entry) || entry.id !== 'financeiro') {
        return entry;
      }

      return {
        ...entry,
        children: entry.children.filter(
          (child) => !INDIVIDUAL_HIDDEN_FINANCE_CHILD_IDS.has(child.id),
        ),
      };
    });
}
